/**
 * @(#)2020/03/16.
 * YxUpload，用于上传数据 -oss逻辑
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import BaseUpload from "../BaseUpload";
import { ossValueFromHandle } from "../tools";
import { YxComponent } from "../../../YxComponent";
import { get, random, toArray, merge } from "../../../../utils";
import UploadFile, { urlToFile } from "../../../../utils/upload/uploadFile";

class UploadOss extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      ossUrl: "",
    };
    this.uploadFile = get(this.props, "uploadFile", new UploadFile(this.props));
    this.id = random();
  }

  get extraUploadParam() {
    return {};
  }

  get uploadUrl() {
    return this.state.ossUrl;
  }

  beforeUploadExtraAction = async () => {
    if (this.state.ossUrl == "" || this.state.ossUrl == null) {
      await this.uploadFile.getSign("error");
    }
  };

  parseConfig = (setState, baseObj) => {
    return new Promise((resolve) => {
      this.uploadFile
        .getSign()
        .then((config) => {
          this.setState({ ossUrl: config.host });
          setState({ ...baseObj }, resolve);
        })
        .catch((err) => {
          setState({ spin: false }, resolve);
        });
    });
  };

  /**
   * 获得凭证
   *
   * @param {object} setState 父组件的setState函数指针
   * @memberof UploadOss
   */
  getSign = async (setState, ossFactory) => {
    let props = this.props;
    setState({ spin: true });
    const isRead = get(props, "isRead", false);
    const propsList = toArray(get(props, "list", []));
    const list = propsList.slice(0, props.limit || undefined);
    const fileList = list.map((url, index) => urlToFile(url, -index));
    const baseObj = { fileList, spin: false };
    if (isRead) {
      setState(baseObj);
    } else {
      await this.parseConfig(setState, baseObj);
    }
  };

  /**
   * 每个云实现自己的url转换逻辑
   * 直接决定表单的值和展示出来的图片
   *
   * @param {File} {file,fileList，uploadFormList}
   * @returns (urls fullUrls)
   * @memberof UploadOss
   */
  getValueFromHandle = ({ filterList, uploadFormList }) => {
    const ossUrl = this.uploadFile.ossUrl;
    return ossValueFromHandle(ossUrl, filterList, uploadFormList);
  };

  get param() {
    const result = {
      getSign: this.getSign,
      uploadFile: this.uploadFile,
      uploadUrl: this.uploadFile.ossUrl,
      extraUploadParam: this.extraUploadParam,
      getValueFromHandle: this.getValueFromHandle,
      beforeUploadExtraAction: this.beforeUploadExtraAction,
    };
    return merge(result, this.props);
  }

  render() {
    return <BaseUpload {...this.param} />;
  }
}

export default UploadOss;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Upload-Oss/index.js